export const CATEGORY_COLORS = {
  "Cybersecurity": "#E4572E",
  "Data Analytics & Statistics": "#2563EB",
  "Database Design": "#0EA5A0",
  "AI & Cloud Computing": "#F59E0B",
  "Systems Engineering & Product Management": "#7C3AED",
  "Business Strategy & Analytics": "#DB2777",
};

export const PALETTE = ["#E4572E", "#2563EB", "#0EA5A0", "#F59E0B", "#7C3AED", "#DB2777"];

export const colorFor = (cat) => CATEGORY_COLORS[cat] || "var(--accent)";
